import _ColorPalette from './components/color-palette/color-palette.js';
import _Element from './components/element/element.js';
import _ThemeButton from './components/theme-button/theme-button.js';
import _HierarchyButton from './components/hierarchy-button/hierarchy-button.js';

import _BrandingService from './services/branding';

import { HIERARCHY_TYPES as _HIERARCHY_TYPES } from './services/branding';
import { INTENT_TYPES as _INTENT_TYPES } from './services/branding';
import { ELEMENT_TYPES as _ELEMENT_TYPES } from './services/branding';
import { STATE_TYPES as _STATE_TYPES } from './services/branding';
import { PROPERTY_TYPES as _PROPERTY_TYPES } from './services/branding';
import { THEME_IDS as _THEME_IDS } from './services/branding';

export const ColorPalette = _ColorPalette;
export const Element = _Element;
export const ThemeButton = _ThemeButton;
export const HierarchyButton = _HierarchyButton;

export const BrandingService = _BrandingService;

export const HIERARCHY_TYPES = _HIERARCHY_TYPES;
export const INTENT_TYPES = _INTENT_TYPES;
export const ELEMENT_TYPES = _ELEMENT_TYPES;
export const STATE_TYPES = _STATE_TYPES;
export const PROPERTY_TYPES = _PROPERTY_TYPES;
export const THEME_IDS = _THEME_IDS;
